import BaseUseCase from "../../base_use_case.js";
class ListAbilitiesUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/abilities/abilities`,
      params: params
    });
  }
}

const instance = new ListAbilitiesUseCase();
export default instance;